import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { confirmAlert } from 'react-confirm-alert'
import 'react-confirm-alert/src/react-confirm-alert.css'
import classNames from 'classnames'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
import DeleteIcon from '@material-ui/icons/Delete'
import AddIcon from '@material-ui/icons/Add'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import InputAdornment from '@material-ui/core/InputAdornment'
import SearchIcon from '@material-ui/icons/Search'
import Y from '../y18n'
import Styles from './styles'

class TableToolbar extends Component {
  state = {
    searchText: '',
    searchActive: false,
    isEmpty: false
  }

  inputChanged = name => e => {
    this.setState({ [name]: e.target.value })
    if(e.target.value === "")
      this.setState({ isEmpty: true })
    else if(e.target.value.length > 0 && this.state.isEmpty)
      this.setState({ isEmpty: false})
  }

  setValue = (value) => {
    if(!this.state.searchText && !this.state.isEmpty)
      if(value)
        return value

    return this.state.searchText
  }
  toggleSearch = () => {
    this.setState({ searchActive: !this.state.searchActive })
    this.setState({ searchText: '' })
  }

  submitSearch = e => {
    e.preventDefault()
    this.props.storeActions.search(this.state.searchText)
  }

  confirmDialog = (message) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='react-confirm-alert-body'>
            <h1>{Y`Confirm`}</h1>
            <p>{message}</p>
            <p>{Y`Do you want to proceed`}</p>
            <br/>
            <div className={this.props.classes.reactConfirmButtonGroup}>
              <button 
                className={this.props.classes.reactConfirmButtonGroupBtnNeutral}
                onClick={() => {
                  onClose()
                }}>{Y`Cancel`}
              </button>
              <button
                className={this.props.classes.reactConfirmButtonGroupBtnWarning}
                onClick={() => {
                  this.props.storeActions.deleteItems()
                  onClose()
                }}
              >
              {Y`Ok`}
              </button>
            </div>
          </div>
        )
      }
    })
  }

  render () {
    const { classes, store, storeActions, title, hideAddButton, value } = this.props
    return (
      <div>
        <Toolbar
          className={classNames(classes.root, {
            [classes.highlight]: store.selectedItems.length > 0
          })}
        >
          <div className={classes.title}>
            {store.selectedItems.length > 0
              ? <Typography variant='title'>{store.selectedItems.length} {Y`${title}`} {Y`selected`}</Typography>
              : <Typography variant='title' classes={{ title: classes.title }}>
                {Y`${title}`}
              </Typography>}
          </div>
          <div className={classes.toolbarSpacer} />
          <div className={classes.actions}>
            {store.selectedItems.length > 0
              ? <Tooltip title={Y`Delete`}>
                <IconButton aria-label={Y`Delete`} onClick={() => this.confirmDialog(
                  Y`You're about to delete one or multple objects, are you really sure about this?`

                )}>
                  <DeleteIcon />
                </IconButton>
              </Tooltip>
              : hideAddButton
                  ? ''
                  : <Button
                    className={classes.button}
                    variant='raised'
                    color='primary'
                    onClick={() => storeActions.setNew()}
                    style={{ color: '#fff' }}
                    >
                    <AddIcon className={classes.leftIcon} />
                    {Y`Add`}
                  </Button>}
          </div>
        </Toolbar>
        <form className={classes.searchBar} onSubmit={e => this.submitSearch(e)}>
          <TextField
            className={classes.spacer}
            placeholder={Y`Search`}
            value={this.setValue(value)}
            onChange={this.inputChanged('searchText')}
            InputProps={{
              disableUnderline: true,
              classes: {
                root: classes.root,
                input: classes.input
              },
              endAdornment: (
                <InputAdornment position='end'>
                  <IconButton aria-label={Y`Search`} onClick={e => this.submitSearch(e)} style={{ marginTop: '8px' }}>
                    <SearchIcon />
                  </IconButton>
                </InputAdornment>
              )
            }}
            InputLabelProps={{
              shrink: true,
              className: classes.formLabel
            }}
            fullWidth
          />
        </form>
      </div>
    )
  }
}

export default withStyles(Styles)(TableToolbar)



// WEBPACK FOOTER //
// ./src/common/table-toolbar.js